import JoinPage from "./components/join-page"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-spaces-join")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  const { categoryProps, spaceName, spaceB2b } = el.dataset

  createComponent({
    el: el,
    component: JoinPage,
    props: {
      spaceName: spaceName,
      spaceB2b: spaceB2b === "true",
      categoryProps: JSON.parse(categoryProps)
    }
  })
}
